(function($) {
  $(document).ready(function() {
    if (typeof vc !== 'undefined' && vc.font_manager && vc.font_manager.google_fonts) {
      vc.font_manager.google_fonts['Roboto'] = {
        variants: [
          "100", "100italic",
          "300", "300italic",
          "regular", "italic",
          "500", "500italic",
          "700", "700italic",
          "900", "900italic"
        ]
      };
    }
  });
})(jQuery);